import { ITablePlan, ITablePlanObjMetadata } from '@localina/core';
import React from 'react';

interface IProps {
    tablePlan: ITablePlan;
}

const FILLS: Record<string, string> = {
    'small-table': '#005e6e',
    'big-table': '#005e6e',
    'small-table-rounded': '#005e6e',
    'big-table-rounded': '#005e6e',
    floor: '#e6ceaa',
    wall: '#eaeaea',
    'plant-1': '#cfdccb',
    'plant-2': '#cfdccb',
    'plant-3': '#cfdccb',
};

const zIndexOf = (objType: string) => (objType === 'floor' ? 0 : 1);

const boundsOf = (el: ITablePlanObjMetadata) => {
    const size = el.type === 'circle' ? el.radius * 2 : { w: el.width, h: el.height };
    const w = typeof size === 'number' ? size : size.w;
    const h = typeof size === 'number' ? size : size.h;
    return { x: el.left, y: el.top, w, h };
};

export const TablePlanThumbnail: React.FC<IProps> = (props) => {
    const elements = props.tablePlan.canvas?.elements ?? [];
    if (elements.length === 0) {
        return null;
    }

    const boxes = elements.map(boundsOf);
    const minX = Math.min(...boxes.map((b) => b.x));
    const minY = Math.min(...boxes.map((b) => b.y));
    const maxX = Math.max(...boxes.map((b) => b.x + b.w));
    const maxY = Math.max(...boxes.map((b) => b.y + b.h));

    const MIN_EXTENT = 900;
    const contentW = maxX - minX;
    const contentH = maxY - minY;
    const frameW = Math.max(contentW, MIN_EXTENT);
    const frameH = Math.max(contentH, MIN_EXTENT);
    const pad = Math.max(frameW, frameH) * 0.04;
    const viewBox = [
        minX - (frameW - contentW) / 2 - pad,
        minY - (frameH - contentH) / 2 - pad,
        frameW + pad * 2,
        frameH + pad * 2,
    ].join(' ');

    const ordered = [...elements].sort((a, b) => zIndexOf(a.objType) - zIndexOf(b.objType));

    return (
        <svg className="table-plan-card__thumb__svg" viewBox={viewBox} preserveAspectRatio="xMidYMid meet" aria-hidden>
            {ordered.map((el, i) => {
                const fill = FILLS[el.objType] ?? '#005e6e';
                if (el.type === 'circle') {
                    return (
                        <circle key={i} cx={el.left + el.radius} cy={el.top + el.radius} r={el.radius} fill={fill} />
                    );
                }
                return (
                    <rect
                        key={i}
                        x={el.left}
                        y={el.top}
                        width={el.width}
                        height={el.height}
                        rx={el.type === 'image' ? Math.min(el.width, el.height) * 0.2 : el.borderRadius}
                        fill={fill}
                        transform={el.rotation ? `rotate(${el.rotation} ${el.left} ${el.top})` : undefined}
                    />
                );
            })}
        </svg>
    );
};
